import { useState, useCallback } from "react";
import { BaseButton } from "@/components/buttons/BaseButton";
import { useVisitorInfo } from "@/common/hooks";
import "./ExploreNicheNavigation.scss";
import { IItemList, Select } from "@/components/core/Select";
import { onOpenCreateNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { NICHE_SORT_ORDER_OPTIONS } from "@/common/utils/nicheSortOptions";

interface IProps {
  order: string;
  sort: string;
  onSortChange: (order: string, sort: string) => void;
  sortOptions: IItemList[];
}

export const ExploreNicheNavigation = ({ order, sort, onSortChange, sortOptions }: IProps) => {
  const currentUser = useVisitorInfo();
  const [sortOrder, setSortOrder] = useState<string>(sort);

  const toggleShowCreateNiche = useCallback(() => {
    onOpenCreateNichePopup();
  }, []);

  const handleOrderChange = (value: string | null) => {
    if (value === "subscribers" || value === "posts") {
      onSortChange(value, "asc");
    }

    if (value === "name") {
      setSortOrder("asc");
      onSortChange("name", "asc");
    }
  };

  const handleSortChange = (value: string | null) => {
    if (value === null) {
      return;
    }

    setSortOrder(value);
    onSortChange("name", value);
  };

  return (
    <div className="nicheTopNav">
      <Select
        label="Sort by"
        value={order}
        list={sortOptions}
        onChange={handleOrderChange}
      />

      {order === "name" && (
        <Select
          label="Order"
          value={sortOrder}
          list={NICHE_SORT_ORDER_OPTIONS}
          onChange={handleSortChange}
        />
      )}

      {currentUser && (
        <div className="nicheCreateBtn">
          <BaseButton onClick={toggleShowCreateNiche}>Create Niche</BaseButton>
        </div>
      )}
    </div>
  );
};
